module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }